const retrieveOptions = (optionObj) => {
    const retOptions = [];
    optionObj.forEach((options) => {
        const arrItem = { options: [] };
        if (options.label) {
            arrItem.label = options.label;
        }
        arrItem.options.push(...options?.options.map((option) => ({
            value: option.value,
            text: option.key,
        })));
        retOptions.push(arrItem);
    });
    return retOptions;
};
export const parseConfig = (configData, today) => {
    const minDate = today;
    minDate.setDate(today.getDate() + configData.dateMin);
    const maxDate = new Date(configData.dateMax);
    return {
        adults: {
            min: configData.adultsMin,
            max: configData.adultsMax,
            defaultValue: configData.adultsDefault,
        },
        children: {
            min: configData.childrenMin,
            max: configData.childrenMax,
            defaultValue: configData.childrenDefault,
        },
        infants: {
            min: configData.infantsMin,
            max: configData.infantsMax,
            defaultValue: configData.infantsDefault,
        },
        pets: {
            min: configData.petsMin,
            max: configData.petsMax,
            defaultValue: configData.petsDefault,
        },
        dates: {
            min: minDate,
            max: maxDate,
            defaultValue: '',
        },
        destination: {
            defaultValue: configData.destination ?? '',
        },
        destinationId: {
            defaultValue: configData.destinationId ?? '',
        },
        destinationURL: {
            defaultValue: configData.destinationURL ?? '',
        },
        flexibility: {
            options: [...retrieveOptions(configData.flexibilityOptions)],
            defaultValue: configData.flexibilityDefault.toString(),
        },
        duration: {
            options: [...retrieveOptions(configData.durationOptions)],
            defaultValue: configData.durationDefault.toString(),
        },
        ...(configData.accommodationType && {
            accommodationType: {
                options: [...retrieveOptions(configData.accommodationType)],
                defaultValue: configData.accommodationTypeDefault?.toString() ?? '',
            },
        }),
    };
};
//# sourceMappingURL=contentful-parse-search-form-config.js.map